// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PropTypes } from 'prop-types';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import {
  getIsRecapchaEnabled,
  getNewGlobalErrorMessage,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddGiftCardComponent from '../views/AddGiftCard.view';
import { addGiftCardRequest, resetShowNotification } from './AddGiftCard.actions';
import { getCardList } from '../../container/Payment.actions';
import {
  getAddGiftCardResponse,
  getAddGiftCardErrorMessage,
  getshowNotification,
} from './AddGiftCard.selector';
import { routerPush } from '../../../../../../utils';
import AddGiftCardReducer from './AddGiftCard.reducer';
import { AddGiftCardSaga } from './AddGiftCard.saga';
import GlobalErrorComponentReducer from '../../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import {
  hideError,
  setGlobalError,
} from '../../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import { getErrorVisibleState } from '../../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.selectors';

class AddGiftCardContainer extends React.Component {
  componentDidUpdate() {
    const { addGiftCardResponse, getAddGiftCardErr, setGlobalErrorAction, showGlobalError } =
      this.props;
    if (addGiftCardResponse === 'success') {
      this.goBackToPayment();
    }
    if (showGlobalError) {
      setGlobalErrorAction({ message: getAddGiftCardErr, type: 'error' });
    }
  }

  componentWillUnmount() {
    const { getAddGiftCardErr, hideErrorAction } = this.props;
    if (getAddGiftCardErr) {
      const { resetNotificationStateAction } = this.props;
      resetNotificationStateAction();
      hideErrorAction();
    }
  }

  goBackToPayment = () => {
    routerPush('/account?id=payment', '/account/payment');
    return null;
  };

  render() {
    const {
      onAddGiftCardClick,
      getAddGiftCardErr,
      toggleModal,
      showNotification,
      isRecapchaEnabled,
      newGlobalErrorMessageEnabled,
    } = this.props;
    return (
      <AddGiftCardComponent
        onAddGiftCardClick={onAddGiftCardClick}
        addGiftCardResponse={getAddGiftCardErr}
        goBackToPayment={this.goBackToPayment}
        toggleModal={toggleModal}
        showNotification={showNotification}
        isRecapchaEnabled={isRecapchaEnabled}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    onAddGiftCardClick: (payload) => {
      dispatch(addGiftCardRequest(payload));
    },
    resetNotificationStateAction: () => {
      dispatch(resetShowNotification());
    },
    getCardListAction: () => {
      dispatch(getCardList());
    },
    toastMessage: (palyoad) => {
      dispatch(toastMessageInfo(palyoad));
    },
    setGlobalErrorAction: (payload) => {
      dispatch(setGlobalError(payload));
    },
    hideErrorAction: (payload) => {
      dispatch(hideError(payload));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    addGiftCardResponse: getAddGiftCardResponse(state),
    getAddGiftCardErr: getAddGiftCardErrorMessage(state),
    showNotification: getshowNotification(state),
    isRecapchaEnabled: getIsRecapchaEnabled(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    showGlobalError: getErrorVisibleState(state),
  };
};

AddGiftCardContainer.propTypes = {
  onAddGiftCardClick: PropTypes.func,
  getAddGiftCardErr: PropTypes.string,
  addGiftCardResponse: PropTypes.string,
  toggleModal: PropTypes.func,
  resetNotificationStateAction: PropTypes.func,
  getCardListAction: PropTypes.func,
  showNotification: PropTypes.bool.isRequired,
  toastMessage: PropTypes.func.isRequired,
  isRecapchaEnabled: PropTypes.bool.isRequired,
};

AddGiftCardContainer.defaultProps = {
  onAddGiftCardClick: () => {},
  getAddGiftCardErr: null,
  addGiftCardResponse: null,
  toggleModal: () => {},
  resetNotificationStateAction: () => {},
  getCardListAction: () => {},
};

const withReducer = withDynamicReducer([
  { key: 'AddGiftCardReducer', reducer: AddGiftCardReducer },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
]);
const withSaga = useDynamicSaga([{ key: 'AddGiftCardSaga', saga: AddGiftCardSaga }]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(AddGiftCardContainer);
export { AddGiftCardContainer as AddGiftCardContainerVanilla };
